import { Keyboard } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Kbd } from '@/components/ui/kbd'
import { Modal } from '@/components/ui/modal'
import { MAIL_SHORTCUTS } from '../hooks/useMailShortcuts'

export function MailShortcutsDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (v: boolean) => void }) {
  const { t } = useTranslation()
  return (
    <Modal open={open} onOpenChange={onOpenChange} size="md" icon={<Keyboard />} title={t('mail.mailbox.shortcuts.title')} description={t('mail.mailbox.shortcuts.hint')}>
      <dl className="grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-2">
        {MAIL_SHORTCUTS.map((s) => (
          <div key={s.action} className="flex items-center justify-between gap-3 rounded-lg px-2 py-1.5 odd:bg-muted/40">
            <dt className="text-sm">{t(`mail.mailbox.shortcuts.${s.action}`)}</dt>
            <dd className="flex shrink-0 gap-1">
              {s.keys.map((k) => (
                <Kbd key={k} className="h-6 min-w-6 justify-center text-xs">
                  {k}
                </Kbd>
              ))}
            </dd>
          </div>
        ))}
      </dl>
    </Modal>
  )
}
